export default __webpack_public_path__ + "static/media/lynton.611df6cd.jpg";